import { Maybe } from "util/maybe";

import { State } from "data";
import { ClusterId } from "data/models";

export const selectCurrentClusterId = (s: State): Maybe<ClusterId> =>
    s.connection.state.config ? s.connection.state.config.clusterId : undefined;
